import { Injectable } from '@angular/core';
import { TitleStrategy } from '@angular/router';

import type { SuiBreadcrumbItem } from '@semeris/ui';

const APP_NAME = 'Semeris';

/** The tab title for a breadcrumb trail, most specific first: "Kestrel CLO 2025-1 - Meridian - Semeris". */
export function breadcrumbTitle(trail: readonly SuiBreadcrumbItem[]): string {
  const parts = [trail.at(-1)?.label, trail.at(0)?.label, APP_NAME];

  return [...new Set(parts.filter(Boolean))].join(' - ');
}

/**
 * Ignores route `title`s: `AppComponent` titles every tab from its breadcrumb trail, and the
 * workspace-ui screens' route titles are Zing's own ("Sheets - Workspace").
 */
@Injectable({ providedIn: 'root' })
export class BreadcrumbTitleStrategy extends TitleStrategy {
  public override updateTitle(): void {
    // `AppComponent` sets the title from the breadcrumb trail.
  }
}
